import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92ebed8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-service-license mt-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { LANG_TYPE } from '@/i18n/langType'
import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpLicense',
  props: {
  // 言語設定
  language: {
    type: String,
    default: LANG_TYPE.JA,
  },
},
  setup(__props) {

const props = __props

log.trace('HelpLicense setup start.')

// プロパティ定義


log.trace('HelpLicense setup end.')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.contents2', props.language)), 1),
    _hoisted_2,
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.contents3', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.contents4', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.contents5', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.contents6', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.contents7', props.language)), 1),
    _hoisted_3,
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.title', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part1.title', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part1.contents1', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part1.contents2', props.language)), 1),
    _hoisted_4,
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part2.title', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part2.contents', props.language)), 1),
    _hoisted_5,
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part3.title', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part3.contents', props.language)), 1),
    _hoisted_6,
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part4.title', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part4.contents', props.language)), 1),
    _hoisted_7,
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part5.title', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part5.contents', props.language)), 1),
    _hoisted_8,
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part6.title', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading1.part6.contents', props.language)), 1),
    _hoisted_9,
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading2.title', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading2.contents', props.language)), 1),
    _hoisted_10,
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading3.title', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading3.contents', props.language)), 1),
    _hoisted_11,
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading4.title', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading4.contents', props.language)), 1),
    _hoisted_12,
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading5.title', props.language)), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.agree.heading5.contents', props.language)), 1),
    _hoisted_13
  ]))
}
}

})